import { render, staticRenderFns } from "./AppBody.vue?vue&type=template&id=5b498c1a"
import script from "./AppBody.vue?vue&type=script&lang=js"
export * from "./AppBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports